module.exports = __webpack_public_path__ + "static/media/logo 102_2.3a66c36b.jpeg";